module.exports = __webpack_public_path__ + "static/media/hdfc.c2cc21e6.svg";